// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"180dc86b","453":"b12d334e","501":"d2e8d0d8","727":"092f191f"}[chunkId] + ".chunk.js";
};